export default "__VITE_ASSET__Dkfvk$8J__"